
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  font-family:var(--ff-dmsans);
}

.wrapper{
  gap:var(--space-2xl-3xl);
}

.wrapper.is-desktop{
    display:grid;
    grid-template-columns:minmax(300px, 360px) minmax(300px, auto);
  }

.wrapper.is-desktop.snug-fit{
      gap:var(--space-3xs-2xl);
      grid-template-columns:minmax(200px, 320px) minmax(370px, auto);
    }

.wrapper.is-mobile{
    display:flex;
    flex-direction:column;
  }

.sidebar{
  display:flex;
  flex-direction:column;
  gap:var(--space-l-xl);
}

.main-content{
  overflow:hidden;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  gap:2rem;
}
`;